import React from "react";

const ArrowSplitVertical = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="rgba(0, 0, 0, 0.3803921568627451)" d="M18 16v-3h-3v9h-2V2h2v9h3V8l4 4l-4 4M2 12l4 4v-3h3v9h2V2H9v9H6V8l-4 4Z"/></svg>
  );
};

export default ArrowSplitVertical;
